// /app/frontend/src/data/formationsEleve.js
// Contenu natif codevoiture.fr — Parcours de formation Élève
// Conforme aux référentiels officiels du permis B (REMC, arrêtés du 22/12/2009 modifiés).

export const PRE_REQUIS_COMMUNS = [
  { titre: 'Âge minimum légal', desc: '15 ans pour démarrer l\'AAC · 17 ans pour passer l\'examen pratique B · 17 ans pour conduire seul (depuis le 01/01/2024).', icon: 'calendar' },
  { titre: 'ASSR 2 ou ASR', desc: 'Attestation Scolaire de Sécurité Routière 2 (en 3e) OU Attestation de Sécurité Routière. Obligatoire pour s\'inscrire.', icon: 'shield' },
  { titre: 'Pièces d\'identité', desc: 'Carte d\'identité ou passeport en cours de validité + justificatif de domicile de moins de 6 mois.', icon: 'id' },
  { titre: 'JDC / Recensement', desc: 'Attestation de recensement (16 ans) ou Journée Défense et Citoyenneté (entre 16 et 25 ans).', icon: 'file' },
  { titre: 'Aptitude médicale visuelle', desc: 'Vue corrigée à au moins 5/10 sur les deux yeux. Pas de visite médicale obligatoire au permis B simple.', icon: 'eye' },
  { titre: 'Numéro NEPH', desc: 'Numéro d\'Enregistrement Préfectoral Harmonisé. Délivré par l\'ANTS via ton auto-école ou directement en ligne.', icon: 'hash' },
];

export const ETAPES_COMMUNES = [
  { n: 1, label: 'Inscription', titre: 'Constitution du dossier', desc: 'Tu rassembles les pièces, l\'auto-école génère ton numéro NEPH et déclenche la formation.', duree: '1 à 4 semaines' },
  { n: 2, label: 'Évaluation initiale', titre: 'Évaluation de départ', desc: 'Une heure d\'analyse en salle ou en voiture pour estimer le nombre d\'heures dont tu vas avoir besoin (volume mini réglementaire : 20h).', duree: '1 h' },
  { n: 3, label: 'Code', titre: 'Apprentissage théorique (ETG)', desc: '9 thèmes officiels, ~40 questions à l\'examen, score d\'admission : 35/40. Tu peux passer le Code dès 17 ans.', duree: '~30 à 50 h personnelles' },
  { n: 4, label: 'Conduite', titre: 'Formation pratique (REMC)', desc: '20 heures minimum réglementaires, 4 compétences (C1→C4), 38 sous-compétences à valider dans ton livret.', duree: '20 à 35 h en moyenne' },
  { n: 5, label: 'Examen', titre: 'Épreuve pratique', desc: '32 minutes derrière le volant avec un examinateur certifié. Évaluation sur 31 critères + 12 points minimum requis.', duree: '32 min' },
  { n: 6, label: 'Permis probatoire', titre: 'Premiers pas en autonomie', desc: 'Permis valable, période probatoire de 3 ans (2 si AAC), capital de 6 points jusqu\'à la fin du probatoire.', duree: '2 à 3 ans' },
];

export const PARCOURS = [
  {
    slug: 'permis-b-classique',
    code: 'PERMIS B',
    color: 'red',
    title: 'Permis B classique',
    sub: 'Filière traditionnelle · dès 17 ans',
    age: '17 ans pour passer l\'examen · 17 ans pour conduire seul (depuis le 01/01/2024)',
    intro: 'La voie standard. Tu apprends, tu passes le Code, puis tu enchaînes les heures de conduite avec ton moniteur ECSR jusqu\'à l\'examen pratique.',
    duree_globale: '6 à 12 mois en moyenne',
    heures_min: '20 h',
    avantages: [
      'Démarrage possible dès 17 ans pour la conduite (loi 01/01/2024)',
      'Pas de contrainte familiale post-formation',
      'Probatoire de 3 ans (versus 2 en AAC)',
    ],
    points_attention: [
      'Tu dois atteindre les 20h mini avant de pouvoir passer l\'examen.',
      'Pas de "passerelle accompagnée" — tu seras seul derrière le volant dès le permis obtenu.',
    ],
  },
  {
    slug: 'aac-conduite-accompagnee',
    code: 'AAC',
    color: 'red',
    title: 'Apprentissage Anticipé de la Conduite (AAC)',
    sub: 'Dès 15 ans · avec un accompagnateur',
    age: '15 ans pour démarrer · 17 ans pour l\'examen · 17 ans pour conduire seul (depuis le 01/01/2024)',
    intro: 'Tu démarres tôt et tu accumules de l\'expérience encadrée par un proche. Statistiquement, les jeunes en AAC ont nettement moins d\'accidents la première année.',
    duree_globale: '1 à 3 ans (formation + phase accompagnée mini 1 an)',
    heures_min: '20 h en auto-école + 3000 km mini accompagné',
    avantages: [
      'Permis probatoire réduit à 2 ans (vs 3 en classique)',
      'Capital de 6 points dès le départ (vs 6 aussi mais avec moins de risque grâce à l\'expérience)',
      'Assurance souvent moins chère pour les jeunes ex-AAC',
      'Taux de réussite à l\'examen pratique supérieur (~75 % vs 55 % en filière classique)',
    ],
    points_attention: [
      'Tu DOIS suivre les 20h minimum en auto-école AVANT de commencer la phase accompagnée.',
      'Tu DOIS faire au moins 3000 km accompagné sur 1 an minimum avant de pouvoir passer l\'examen pratique.',
      '2 RDV pédagogiques OBLIGATOIRES avec ton accompagnateur et ton moniteur ECSR.',
    ],
    rdv_obligatoires: [
      {
        n: 1,
        label: 'RDV 1 — entre le 4e et le 6e mois OU 1000 km',
        titre: 'Bilan intermédiaire',
        duree: '3 h (2 h voiture + 1 h salle)',
        contenu: [
          'Bilan des kilomètres parcourus en accompagné et des situations rencontrées.',
          'Sortie en voiture avec moniteur ECSR + accompagnateur : observation, conseils, ajustements.',
          'Travail en salle sur les bonnes pratiques, les difficultés vécues, les points à renforcer.',
        ],
        objectif: 'Corriger les mauvais réflexes avant qu\'ils ne s\'installent. C\'est le moment où on ajuste la communication entre toi et ton accompagnateur.',
      },
      {
        n: 2,
        label: 'RDV 2 — vers 3000 km parcourus accompagné',
        titre: 'Bilan final avant examen',
        duree: '3 h (2 h voiture + 1 h salle)',
        contenu: [
          'Évaluation des compétences acquises pendant la phase accompagnée.',
          'Mise en situation d\'examen blanc avec moniteur + accompagnateur.',
          'Validation finale du livret d\'apprentissage et décision : prêt pour l\'examen ?',
        ],
        objectif: 'Confirmer que tu es prêt à passer le permis pratique. Si ce n\'est pas le cas, des heures supplémentaires de pratique sont prescrites.',
      },
    ],
    role_accompagnateur: {
      titre: 'Rôle de l\'accompagnateur (parent ou proche)',
      pre_requis: [
        'Permis B depuis au moins 5 ans sans interruption (à la date du début de l\'accompagnement).',
        'Accord écrit de l\'assureur (extension de la police auto à l\'élève AAC).',
        'Mention sur le contrat d\'assurance et inscription sur le livret d\'apprentissage.',
      ],
      missions: [
        'Pratiquer avec l\'élève dans des conditions variées (jour, nuit, pluie, autoroute, ville).',
        'Toujours laisser le volant à l\'élève SANS jamais reprendre la conduite (sauf cas exceptionnel).',
        'Suivre les conseils du moniteur ECSR (RDV 1) et corriger en douceur, sans crier.',
        'Tenir le livret à jour : kilomètres parcourus, conditions, observations.',
      ],
      a_eviter: [
        'Crier, juger, comparer avec d\'autres conducteurs.',
        'Conduire alors que c\'est ton tour de conduire (interdit légalement, sauf danger).',
        'Sauter le RDV 1 ou le RDV 2 : tu perds le bénéfice de l\'AAC.',
      ],
    },
  },
  {
    slug: 'conduite-supervisee',
    code: 'CS',
    color: 'red',
    title: 'Conduite Supervisée (CS)',
    sub: '18 ans · après échec ou choix tardif',
    age: '18 ans minimum',
    intro: 'Tu as échoué à l\'examen ou tu veux gagner en expérience avant de conduire seul ? La Conduite Supervisée te permet de continuer à pratiquer avec un accompagnateur après les 20 h de formation minimum, sans kilométrage imposé.',
    duree_globale: 'Phase supervisée libre (aucun kilométrage minimum ni maximum imposé)',
    heures_min: '20 h en auto-école + phase supervisée libre',
    avantages: [
      'Souplesse : pas de durée minimale obligatoire en accompagné',
      'Permet de rattraper un échec à l\'examen pratique',
      'Réduit le stress avant de passer/repasser le permis',
    ],
    points_attention: [
      'Aucun bénéfice sur la période probatoire (reste à 3 ans).',
      '1 RDV pédagogique préalable obligatoire avec accompagnateur + moniteur ECSR.',
    ],
    rdv_obligatoires: [
      {
        n: 1,
        label: 'RDV préalable avant la phase supervisée',
        titre: 'Préparation à la conduite supervisée',
        duree: '2 h (1 h voiture + 1 h salle)',
        contenu: [
          'Sortie en voiture avec accompagnateur et moniteur ECSR.',
          'Briefing sur les règles de la conduite supervisée.',
          'Conseils ciblés sur les compétences à travailler.',
        ],
        objectif: 'Cadrer la phase supervisée et donner les bons réflexes à l\'accompagnateur.',
      },
    ],
  },
  {
    slug: 'b96',
    code: 'B96',
    color: 'red',
    title: 'Extension B96 (remorque)',
    sub: 'Pour tracter > 750 kg cumulé',
    age: 'Permis B en cours de validité',
    intro: 'Tu veux tirer une caravane ou une remorque dont le PTAC dépasse 750 kg ET dont l\'ensemble (voiture + remorque) dépasse 3 500 kg ? Le B96 est obligatoire.',
    duree_globale: '7 heures de formation en 1 journée',
    heures_min: '7 h (4 h pratique + 3 h théorie + manœuvres)',
    avantages: [
      'Pas d\'examen — juste une formation de 7 h validée par l\'auto-école.',
      'Te permet de tirer jusqu\'à 4 250 kg d\'ensemble (voiture + remorque).',
      'Pas de visite médicale (sauf si > 4 250 kg → là il faut le BE).',
    ],
    points_attention: [
      'Si l\'ensemble dépasse 4 250 kg : il faut le permis BE complet (avec examen).',
      'Pratique différente : trajectoires, freinage, marche arrière inversée.',
    ],
  },
];
